import { useInfiniteAddresses } from '@ukpostbox/client-data';
import {
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	FlexGap,
	FormWrapperMinimum,
	SelectItemType,
	StackHorizontal,
} from '@ukpostbox/frontend-framework';
import { Controller, useFormContext } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React from 'react';
import { IncludeExclude } from '../IncludeExclude';

type RecipientConditionType = {
	name: string;
	defaultValue: any;
	defaultIncludesValue: boolean;
	changeCallback: (value: any) => void;
};

function RecipientCondition(props: RecipientConditionType) {
	const { control, getValues, getFieldState } = useFormContext();

	const { data, status } = useInfiniteAddresses();

	const AddressOptions: Array<SelectItemType> = data
		? data.pages.map(
				(page) =>
					page?.data &&
					page.data.filter((address, index: number) =>
						address ? { label: address.label, value: address.value } : null,
					),
			)[0]
		: [];

	return (
		<StackHorizontal gap={FlexGap.ExtraSmall}>
			<IncludeExclude name={`${props.name}.includes`} defaultValue={props.defaultIncludesValue} />

			<Controller
				control={control}
				name={`${props.name}.values`}
				defaultValue={props.defaultValue}
				rules={{ required: true, validate: (e) => (e.length > 0 ? 'Recipient is required' : true) }}
				render={({ field, fieldState }) => (
					<FormWrapperMinimum
						invalid={getFieldState(`${props.name}.values`).invalid}
						validationMessage={getFieldState(`${props.name}.values`).error?.message}
					>
						<ComboBoxControl
							data={AddressOptions}
							defaultValue={field.value}
							forwardValuesCallback={(val) => {
								field.onChange(val);
							}}
							name={field.name}
							placeholder='Select Recipient...'
							loading={status === 'pending'}
							disabled={status === 'error'}
							valueType='number'
							displayType={ComboBoxTypeEnum.Multi}
							displayItemLabelType={ComboBoxItemDisplayEnum.Label}
						/>
					</FormWrapperMinimum>
				)}
			/>
		</StackHorizontal>
	);
}

export { RecipientCondition };
